'use strict';
namespace TR {
    class USP {
        private list: any;
        private useBreakpoint: boolean;
        private breakpoint: number = 1025;
        private classFirst: string ='slick-first';
        private classLast: string = 'slick-last';
        private settings: any = {
            mobileFirst: true,
            rtl: TRPCONFIG.Rtl,
            slidesToShow: 1,
            infinite: false,
            dots: false,
            speed: 250
        };
        private breakpointSettings = {
            responsive: [
                {
                    breakpoint: this.breakpoint,
                    settings: 'unslick'
                }
            ]
        };

        setup(el:any):void {
            this.list = el.find('.slick-usps:first');
            this.initSlick();
            if(this.useBreakpoint) {
                this.onResize();
            }
        }

        initSlick(): void {
            this.destroy();
            const count = this.list.find('.usps-item').length;
            if (count > 1) {
                this.list.addClass(this.classFirst).removeClass(this.classLast);
                this.list.slick(this.useBreakpoint
                    ? _.extend({},this.settings, this.breakpointSettings) : this.settings);
                this.list.on('afterChange', (e, slick, current) => {
                    if (0 === current) {
                        this.list.addClass(this.classFirst);
                    } else if (slick.slideCount - 1 === current) {
                        this.list.addClass(this.classLast);
                    } else {
                        this.list.removeClass(`${this.classFirst} ${this.classLast}`);
                    }
                });
            }
        }

        onResize(): void {
            $(window).resize(_.debounce(() => {
                const w = $('body').innerWidth();
                if (!this.list.hasClass('slick-initialized') && w < this.breakpoint) {
                    this.initSlick();
                }
            }, 300));
        }

        destroy(): void {
            if(this.list.hasClass('slick-initialized')) {
                this.list.slick('unslick');
            }
        }
    }

    angular.module('TR')
        .directive('uniqueSellingPoints', (): ng.IDirective => {
            return {
                restrict: 'E',
                controllerAs : 'usp',
                controller: USP,
                scope: {},
                bindToController : {
                    useBreakpoint: '@'
                },
                link: (scope: any, el: any, attr: ng.IAttributes, controller: USP) => {
                    controller.setup(el);
                    scope.$on('$destroy', () => {
                        controller.destroy();
                    });
                }
            };
        });
}
